'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import RegisterMail from '../components/RegisterMail'
import GridAccordion from '../fx/Accordion'
import Channels from '../base/channels'
import FlowWaypoints from '../fx/FlowWaypoints'
import Splide from '@splidejs/splide'


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--home'
        // Objects
        this.accordions = []
        // Fns
        this.accordion()
        this.events()
        this.trendbookletter = new RegisterMail(this.view.querySelector('.jsRegister--trendbook'))
        this.bandletter = new RegisterMail(this.view.querySelector('.jsRegister--bandletter'))
        this.moodletter = new RegisterMail(this.view.querySelector('.jsRegister--footer'))
        this.slideshow()
        this.slideshowFeatured()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    accordion()
    {
        const $items = this.view.querySelectorAll('.jsAccordion--item');
        if($items.length)
        {
            for(let i = 0; i < $items.length; i++ ) {
                const $item = $items[i]
                let instance =  new GridAccordion($item)
                instance.setup()
                this.accordions.push(instance)
            }
        }
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        this.waypoints.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    events()
    {
        Env.framework.UI.listenTransitionUpdateBg(this.view)
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
        Env.framework.UI.pinRefresh()
        Env.framework.UI.lazy()
    }

    slideshow()
    {
        // new Splide( '.splide' ).mount();
        const $slideshow = this.view.querySelector('.jsSlideshow--view')
        if($slideshow != null) {
            this.slideshow = new Splide($slideshow , {
                arrows: false,
                arrowPath:false,
                type: 'fade',
                autoplay: true,
                interval: 5000,
                rewind: true,
                pauseOnFocus:false,
                pauseOnHover:false,
                pagination:true,
                easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                speed: 1000
            }).mount();
            this.slideshow.on( 'moved', (e,i)=> {
                const $getSlide = this.slideshow.Components.Elements.getSlide(e).slide
                if($getSlide.getAttribute('data-skin') == '1') {
                    Env.$html.classList.add('skin--forceDark')
                } else {
                    Env.$html.classList.remove('skin--forceDark')
                }
            });
        }

    }

    slideshowFeatured()
    {
        for(let $slideshow of this.view.querySelectorAll('.jsFeaturedProducts--view')) {

            if($slideshow != null) {
                const perPage = (Env.mobileCSS)?2:4;
                const gap = (Env.mobileCSS)?20:30;
                const pagination = (Env.mobileCSS)?true:false;
                const padding = (Env.mobileCSS)?{ left: 20, right: 20 }:{ left: 0, right: 0 };
                const fixedWidth = (Env.mobileCSS)?'40%':false;
                this.slideshow = new Splide($slideshow , {
                    arrows: true,
                    arrowPath:'M13.0001 3.46655L7.36673 9.53322L1.7334 3.46655',
                    type: 'slide',
                    autoplay: false,
                    interval: 5000,
                    gap:gap,
                    perPage:perPage,
                    perMove:1,
                    fixedWidth:fixedWidth,
                    rewind: true,
                    pauseOnFocus:false,
                    pauseOnHover:false,
                    pagination:pagination,
                    padding: padding,
                    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                    speed: 400
                }).mount();
            }
        }
    }

    intro()
    {
        const tl = new TimelineLite()
        const $bg = this.view.querySelectorAll('.jsBg')
        const $title = this.view.querySelector('.jsFxTitle')
        const $desc1 = this.view.querySelector('.jsFxDesc')

        tl.add([
            TweenMax.staggerFromTo($bg , .8 , { autoAlpha : 0 , y : 20 } , { autoAlpha : 1 , y : 0 , ease : Power3.easeOut },.1),
            TweenLite.fromTo($title , .8 , { autoAlpha : 0 , y : 20 } , { autoAlpha : 1 , y : 0 , ease : Power3.easeOut , delay : .1 }),
            TweenLite.fromTo($desc1 , .8 , { autoAlpha : 0 , y : 30 } , { autoAlpha : 1 , y : 0 , ease : Power3.easeOut , delay : .2 }),

        ])
    }
}

page = Barba.BaseView.extend({
    namespace: 'home',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;